export function extractListData(responseData) {
    return responseData?.data ?? [];
}

export function extractPagination(responseData) {
    return responseData?.pagination ?? {page: 1, page_size: 50, total: 0, has_next: false};
}

// Error text for a failed response: the API's message (or the HTTP status text when the body isn't
// JSON), plus its Error ID when it has one.
export async function readErrorBody(response) {
    try {
        return await response.json();
    } catch {
        return null;
    }
}

export function errorMessage(body, response) {
    if (!body) return response?.statusText || "Unexpected error";
    const base = body.message ?? body.error ?? (response?.statusText || "Unexpected error");
    return body.error_id ? `${base} (Error ID: ${body.error_id})` : base;
}

export async function readError(response) {
    return errorMessage(await readErrorBody(response), response);
}
